import {Chip} from "@progress/kendo-react-buttons"
import {useInternationalization} from "@progress/kendo-react-intl"
import {CardBody} from "@progress/kendo-react-layout"
import {Popup} from "@progress/kendo-react-popup"
import {MDBRow, MDBCol} from "mdbreact"
import React from "react"
import {TestDetail} from "../../../containers/MotBooking/bookingSlice"

const TestChipWithDetail = ({test}: {test: TestDetail}) => {
    const intl = useInternationalization()

    const chipAnchor = React.useRef<any>()
    const chipContentRef = React.useRef<any>()
    const [toggletestDetail, showTestDetail] = React.useState(false)
    const showTestDetailPopup = () => {
        showTestDetail(!toggletestDetail)
    }
    const blurTimeoutRef = React.useRef<any>()

    const onOpen = (e: any) => {
        chipContentRef.current.focus()
    }

    const onFocus = () => {
        clearTimeout(blurTimeoutRef.current)
    }

    const onBlurTimeout = () => {
        showTestDetail(false)
    }

    const onBlur = () => {
        clearTimeout(blurTimeoutRef.current)
        blurTimeoutRef.current = setTimeout(onBlurTimeout, 200)
    }

    const chipContent = (
        <span
            className="clip-text"
            style={{
                width: "75px",
            }}
            onClick={showTestDetailPopup}
            ref={chipAnchor}
        >
            {test.code}
        </span>
    )

    return (
        <>
            <Chip children={chipContent} className="me-2"></Chip>
            <Popup
                className={"popup-right-bottom"}
                offset={{top: 10, left: 0}}
                anchor={chipAnchor.current}
                anchorAlign={{
                    horizontal: "right",
                    vertical: "bottom",
                }}
                popupAlign={{
                    horizontal: "right",
                    vertical: "top",
                }}
                show={toggletestDetail}
                onOpen={onOpen}
                popupClass={"popup-content"}
            >
                <div ref={chipContentRef} tabIndex={0} onFocus={onFocus} onBlur={onBlur}>
                    <CardBody className="p-2">
                        <h6>{test.code}</h6>
                        <p>
                            {test.test}
                            <hr className="mt-2" />
                        </p>

                        <MDBRow>
                            <MDBCol md="6">Axle</MDBCol>
                            <MDBCol md="6">{test.axle}</MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md="6">Duration</MDBCol>
                            <MDBCol md="6">{test.duration} min</MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md="6">Test Fee</MDBCol>
                            <MDBCol md="6">
                                {intl.formatNumber(test.charges, {style: "currency", minimumFractionDigits: 2})}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="pt-2">
                            <MDBCol md="12">{test.testType}</MDBCol>
                        </MDBRow>
                    </CardBody>
                </div>
            </Popup>
        </>
    )
}
export default TestChipWithDetail
